import { useEffect, useState } from "react";
import { audio } from "../lib/audio";
import { tx } from "../lib/tx";

/**
 * Persistent top-CENTER "voice is speaking" indicator, independent of the
 * existing bottom `.cf-caption-bar`. Two jobs for hearing-impaired learners:
 *  1. Always visible during a run, so a learner always knows voice narration
 *     CAN occur here (a small dim pill when idle).
 *  2. When a line plays, it animates (equalizer bars) and shows the exact
 *     text — a second, higher-attention cue than the bottom bar alone.
 * Deliberately top-CENTER (not top-right) so it never collides with `.guide`
 * (top-right) or the various call-screen top-right badges (`.vc-timer` etc.);
 * the caller suppresses it entirely during video/voice-call beats, which own
 * a top-center banner of their own (`.vc-banner`/`.dfc-banner`).
 */
export function VoicePanel() {
  const [caption, setCaption] = useState<string | null>(audio.getCaption());
  const [speaking, setSpeaking] = useState<boolean>(audio.isSpeaking());

  useEffect(() => {
    const offC = audio.subscribeCaption(setCaption);
    const offS = audio.subscribeSpeaking(setSpeaking);
    return () => {
      offC();
      offS();
    };
  }, []);

  return (
    <div className={`voice-panel ${speaking ? "voice-panel--speaking" : ""}`} role="status" aria-live="polite">
      <div className="voice-panel-head">
        <span className="voice-panel-bars" aria-hidden>
          <span />
          <span />
          <span />
          <span />
        </span>
        <span className="voice-panel-label">{speaking ? tx("Voice speaking") : tx("Voice")}</span>
      </div>
      {speaking && caption && <div className="voice-panel-text">{caption}</div>}
    </div>
  );
}
